import { initializeApp, getApps } from 'firebase/app'
import { getMessaging, getToken, deleteToken, onMessage } from 'firebase/messaging'

let firebaseApp = null
let messaging = null

try {
  const firebaseConfig = {
    apiKey: "AIzaSyC0GH6CSCSekD6rzIAFybpB0LClmz2fbNo",
    authDomain: "igus-visitor.firebaseapp.com",
    projectId: "igus-visitor",
    storageBucket: "igus-visitor.firebasestorage.app",
    messagingSenderId: "1016802928879",
    appId: "1:1016802928879:web:1b99da9ade6324f4c5531a",
    measurementId: "G-B2BY5JP1DB"
  }

  // Prevent duplicate initialization
  if (!getApps().length) {
    firebaseApp = initializeApp(firebaseConfig)
    messaging = getMessaging(firebaseApp)
  } else {
    firebaseApp = getApps()[0]
    messaging = getMessaging(firebaseApp)
  }
} catch (error) {
  console.error('Firebase initialization failed:', error)
}

export { firebaseApp, messaging, getToken, deleteToken, onMessage }
